import {
	type CommandConstructor,
	type CommandProperties,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

export interface InlineInputBoxErrorMessageCommandProperties extends CommandProperties {
	error: {
		message: {
			content: string;
			status_code?: number;
			message_template?: string;
		};
		metadata: {
			error_message?: string;
			request_id?: string;
			timeout?: number;
		};
	};
	/** When true, the side chat should be opened to display the error. */
	openChatOnError?: boolean;
	/** The conversation ID to open in the side chat. */
	conversationId?: string;
}

/**
 * A command sent by the rovo client to send the error message to the inline input box.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to send the error message to the inline input box.
 */
export const InlineInputBoxErrorMessageCommand: CommandConstructor<
	InlineInputBoxErrorMessageCommandProperties,
	void
> = createCommand<InlineInputBoxErrorMessageCommandProperties, void>(
	'inline-input-box-error-message-command',
);
